import React from 'react';
import Size1 from './Size1.jsx';
import Size2 from './Size2.jsx';
import ConfirmSize2 from './ConfirmSize2.jsx';

export default function Step2(props) {
  const { sizes, getStandard, getLocation, getSneakerSize, getSneakerSize2, getConfirmSneakerSize2, setConfirmSneakerSize2, setSneakerSize, setSneakerSize2, isWomens, isSneaker } = props;
  const strings = window.themeStrings || {};

  return (
    <div className="form-body">
      <Size1 location={getLocation} getSize={getSneakerSize} setSize={setSneakerSize} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label={strings.fit_finder_step2_sneaker_size} />
      {getSneakerSize.us && <Size2 location={getLocation} getSize1={getSneakerSize} getSize2={getSneakerSize2} setSize2={setSneakerSize2} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label={strings.fit_finder_step2_other_sizes} />}
      {getSneakerSize2.us > getSneakerSize.us && <ConfirmSize2 location={getLocation} getSize2={getSneakerSize2} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} getConfirmSneakerSize2={getConfirmSneakerSize2} setConfirmSneakerSize2={setConfirmSneakerSize2} />}
    </div>
  )
}